var _style, _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelemetria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 224.73 200",
    style: {
      enableBackground: "new 0 0 224.73 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000059282749434618212020000004182977674921285308_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:url(#SVGID_00000139980289016165848240000015893488007693614231_);}\r\n\t.st4{fill:none;stroke:url(#SVGID_00000043418371517985214890000000667001092957110404_);stroke-width:1.414;stroke-miterlimit:10;}\r\n\t.st5{fill:url(#SVGID_00000139292895788176069450000010569740345707641221_);}\r\n\t.st6{fill:url(#SVGID_00000169524353891247953360000016469082972822435474_);}\r\n\t.st7{fill:url(#SVGID_00000152960571679328857150000006471656724879952010_);}\r\n\t.st8{fill:url(#SVGID_00000156548071381985570000000010162131059664735928_);}\r\n\t.st9{fill:url(#SVGID_00000078032293932445737290000015341112423007751823_);}\r\n\t.st10{fill:url(#SVGID_00000009588982101062569490000001647561793285555352_);}\r\n\t\r\n\t\t.st11{fill:none;stroke:url(#SVGID_00000179624044667906733810000006904004633535426734_);stroke-width:1.0757;stroke-miterlimit:10;}\r\n\t.st12{fill:url(#SVGID_00000103257681428931972640000008004794236537946024_);}\r\n\t.st13{fill:url(#SVGID_00000084502507878739258470000009889956789244395656_);}\r\n\t.st14{fill:url(#SVGID_00000087407362250665761830000000359824005687170745_);}\r\n\t.st15{fill:url(#SVGID_00000174580027138916784190000000659257495564123312_);}\r\n\t.st16{fill:url(#SVGID_00000054956542291269050060000014149178786457008058_);}\r\n\t.st17{fill:url(#SVGID_00000093887939868964848970000005426450189547012740_);}\r\n\t.st18{fill:url(#SVGID_00000098210539618157920390000008055102837402243993_);}\r\n\t.st19{fill:url(#SVGID_00000134238992804402500600000016772767658966749327_);}\r\n\t.st20{fill:url(#SVGID_00000016760991284635621690000013092296579357079461_);}\r\n\t.st21{fill:url(#SVGID_00000116210855472409099310000004847625765390493843_);}\r\n\t.st22{fill:url(#SVGID_00000091008969653554831470000014920108092394601912_);}\r\n\t.st23{fill:url(#SVGID_00000006697030302801220100000001266285350157737655_);}\r\n\t.st24{fill:url(#SVGID_00000017509066484029365050000009839399388299697822_);}\r\n\t.st25{fill:url(#SVGID_00000042724029976648601340000002490375852906588339_);}\r\n\t.st26{fill:url(#SVGID_00000074427496835675788440000016246870272884987018_);}\r\n\t.st27{fill:url(#SVGID_00000131362820696892181600000009470438938328337295_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.4064,
    y1: -17.6674,
    x2: 194.1359,
    y2: 154.0621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.73,6.16v132.27c0,3.4-2.76,6.16-6.16,6.16H104.9V67.44c0-6.86-5.58-12.44-12.43-12.44H40.44 C33.58,55,28,60.59,28,67.44v77.14H6.16c-3.4,0-6.16-2.76-6.16-6.16V6.16C0,2.75,2.76,0,6.16,0h212.42 C221.97,0,224.73,2.75,224.73,6.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103250762264910607050000010253616567252102784_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.6427,
    y1: -49.2973,
    x2: 165.7428,
    y2: 62.8027
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103250762264910607050000010253616567252102784_)"
    },
    d: "M224.73,6.16v9.09H0V6.16 C0,2.76,2.76,0,6.16,0h212.42C221.97,0,224.73,2.76,224.73,6.16z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 10.06,
    cy: 8.07,
    r: 2.36
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 20.59,
    cy: 8.07,
    r: 2.36
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 31.12,
    cy: 8.07,
    r: 2.36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170236120223104926510000018124623725152122019_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.7374,
    y1: 20.9888,
    x2: 210.4175,
    y2: 40.7169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170236120223104926510000018124623725152122019_)"
    },
    d: "M200.3,36.85h-56.06 c-1.27,0-2.3-1.03-2.3-2.3v-4.82c0-1.27,1.03-2.3,2.3-2.3h56.06c1.27,0,2.3,1.03,2.3,2.3v4.82C202.6,35.82,201.57,36.85,200.3,36.85 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027595634120858647690000012619309025314361219_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.6642,
    y1: 32.134,
    x2: 59.0823,
    y2: 32.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000027595634120858647690000012619309025314361219_)",
      strokeWidth: 1.414,
      strokeMiterlimit: 10
    },
    d: " M56.6,36.85H24.14c-0.98,0-1.77-0.79-1.77-1.77v-5.88c0-0.98,0.79-1.77,1.77-1.77H56.6c0.98,0,1.77,0.79,1.77,1.77v5.88 C58.38,36.05,57.58,36.85,56.6,36.85z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183240331327753944810000005948475416312919977_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.3486,
    y1: 89.092,
    x2: 188.6406,
    y2: 87.1206
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183240331327753944810000005948475416312919977_)"
    },
    d: "M188.75,98.41 c-2.19,0.33-4.41,0.43-6.58-0.06c-7.98-1.78-9.95-10.77-11.45-17.61c-0.83-3.8-1.54-7.74-3.16-11.31 c-0.43-0.95-1.09-2.61-2.34-2.62c-1.46,0-2.44,2.17-3.02,3.23c-1.58,2.87-2.61,6-3.35,9.18c-1.5,6.46-1.83,13.11-2.98,19.62 c-0.79,4.51-2.59,10.6-7.87,11.53c-2.63,0.46-5.42-0.57-7.51-2.13c-2.27-1.69-3.75-4.07-4.76-6.69c-1.42-3.71-1.79-7.69-2.72-11.53 c-0.46-1.87-0.97-3.8-1.89-5.51c-0.31-0.59-0.72-1.25-1.25-1.62c-0.48-0.34-0.93-0.36-1.49,0.09c-1.13,0.89-1.83,2.65-2.33,3.95 c-0.53,1.38-0.9,2.82-1.2,4.26c-0.63,3-0.98,6.07-1.82,9.02c-0.76,2.67-2.03,5.99-4.53,7.5c-3.06,1.86-5.77-1.19-7.47-3.43 c-3.68-4.86-5.17-10.94-6.15-16.86v-9.97c0.85,5.1,1.34,10.26,2.61,15.28c0.78,3.07,1.84,6.08,3.48,8.8 c0.83,1.37,1.79,2.65,2.91,3.79c1.12,1.14,2.55,2.02,4.04,0.99c1.27-0.87,2.07-2.41,2.69-3.78c0.61-1.35,1.02-2.78,1.35-4.22 c0.7-2.99,1.03-6.06,1.78-9.04c0.38-1.49,0.86-2.94,1.53-4.32c0.59-1.21,1.34-2.67,2.53-3.39c1.48-0.9,2.97-0.12,3.92,1.13 c1.11,1.47,1.71,3.32,2.22,5.06c0.54,1.83,0.93,3.69,1.28,5.57c0.83,4.45,1.64,9.42,5,12.75c1.82,1.8,4.66,3.27,7.29,2.88 c2.26-0.33,3.9-2.06,4.94-3.98c1.37-2.51,1.81-5.4,2.24-8.18c0.52-3.31,0.87-6.65,1.32-9.97c0.86-6.41,2.09-12.94,5.49-18.55 c0.72-1.2,1.67-2.55,3.12-2.87c1.42-0.32,2.59,0.57,3.36,1.68c1.11,1.61,1.75,3.67,2.3,5.54c1.16,3.88,1.81,7.88,2.81,11.8 c0.88,3.44,2.01,7.15,4.54,9.77c2.81,2.92,6.87,3.37,10.71,2.8C189.3,96.81,189.71,98.26,188.75,98.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059275112526691110500000014714417118629995431_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.0635,
    y1: 84.0656,
    x2: 173.4636,
    y2: 155.3056
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000059275112526691110500000014714417118629995431_)"
    },
    points: "28,124.95 28,126.69 22.08,126.69  22.08,58.08 21.2,59.68 19.78,58.89 22.95,53.09 26.11,58.89 24.68,59.68 23.81,58.08 23.81,124.95 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085229665279866822110000017901233279274604173_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.8966,
    y1: 125.732,
    x2: 205.8438,
    y2: 125.732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000085229665279866822110000017901233279274604173_)"
    },
    points: "205.84,125.73 200.04,128.9  199.26,127.47 200.69,126.69 104.9,126.69 104.9,124.95 201.02,124.95 199.26,123.99 200.04,122.56 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108285495835902196780000013687731260656743557_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.6149,
    y1: 74.704,
    x2: 186.2064,
    y2: 74.704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108285495835902196780000013687731260656743557_)"
    },
    d: "M151.32,75.36h-40.02 c-0.36,0-0.65-0.29-0.65-0.65l0,0c0-0.36,0.29-0.65,0.65-0.65h40.02c0.36,0,0.65,0.29,0.65,0.65l0,0 C151.97,75.06,151.68,75.36,151.32,75.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133508658207371915130000008186901857762860961_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.6149,
    y1: 74.704,
    x2: 186.2064,
    y2: 74.704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133508658207371915130000008186901857762860961_)"
    },
    d: "M187.48,75.36h-10.13 c-0.36,0-0.65-0.29-0.65-0.65l0,0c0-0.36,0.29-0.65,0.65-0.65h10.13c0.36,0,0.65,0.29,0.65,0.65l0,0 C188.13,75.06,187.84,75.36,187.48,75.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095324795588675854930000003390411064200389270_",
    gradientUnits: "userSpaceOnUse",
    x1: 4210.7476,
    y1: -1721.7673,
    x2: 4315.6665,
    y2: -1669.5219,
    gradientTransform: "matrix(1 0 0 1 -4196.2568 1825.6512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095324795588675854930000003390411064200389270_)"
    },
    d: "M92.96,200H40.94 c-4.1,0-7.43-3.33-7.43-7.43V67.44c0-4.1,3.33-7.43,7.43-7.43h52.02c4.1,0,7.43,3.33,7.43,7.43v125.13 C100.39,196.67,97.06,200,92.96,200z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103969787071588258300000012798989986528553372_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.4619,
    y1: 72.2176,
    x2: 58.5918,
    y2: 72.2176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000103969787071588258300000012798989986528553372_)",
      strokeWidth: 1.0757,
      strokeMiterlimit: 10
    },
    d: " M57.12,74.81H40.93c-0.51,0-0.93-0.42-0.93-0.93v-3.32c0-0.51,0.42-0.93,0.93-0.93h16.19c0.51,0,0.93,0.42,0.93,0.93v3.32 C58.05,74.39,57.64,74.81,57.12,74.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026842655109800580460000015118391228827241861_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.1763,
    y1: 66.4946,
    x2: 101.8945,
    y2: 78.6723
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026842655109800580460000015118391228827241861_)"
    },
    d: "M91.8,74.81H64.84 c-0.39,0-0.7-0.32-0.7-0.7v-3.99c0-0.39,0.32-0.7,0.7-0.7H91.8c0.39,0,0.7,0.32,0.7,0.7v3.99C92.5,74.49,92.19,74.81,91.8,74.81z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.4
    },
    width: 47,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAxCAYAAACcXioiAAAACXBIWXMAAAsSAAALEgHS3X78AAAG ZElEQVRoge1aiW7bRhB9PHTLkh0fTVunCNL+/ye1aeIktus4kURbEg+xIPAmeR6TlmQJKAqEwEKK xd2dNzNvjt3gx/MfP8Eetw/cpz4lv5d1E/ex6a7zA46QI5DfKqFXMsp9AnkugMAJHQGIZUSydgEg k1HgO5Cdn3gHwSshWxwdji4/2wRWCZoCuAdwx7HcpxW2AeAFrwTtARgAGMoY8LfqvZxC3wK44Tor 7NGVNgVgwsfUbh/ACMAhgCMZYwLp0QKVtr8A+Mj5GS1SCDewC5BNAKjwXQpYCXsK4CWAM35/IQC6 nFu5zjXBLGiNBQFUT+GssTWQdQC88AcATgD8DOAVgHN+P6U1Dqj9FgWbcW4F5CuACa0SEEhGN8uF 3FsR/CkAXvgRhf8VwGuO32iFI3EdI3BOIAta55iAQBecE8yCY0n3ysXF1gKJttD8KTX+BsAfAH4X AMd8p8/3W5xfiJAZgZkyqjEUi8X8HdtYoAmAxfZOg/Bv6EJndB2LPC1JZCW1aZot+c6YgKvhLafy bMSLOgCWnNoU7Jhuo8KfE9RYNB6J8KAvZ+IWAQW1AGDEPxTit0SmUiJVI4g6DgSi/RE3eiV+b8KP uGnsSgeviJhrWY5oC09S8uIzFeXB3HKtpfDiSQAmSIvaOqSPn9PffyGR1wkPZ/5IklufowKxIpmP uNeIILtiCa2jAg+izgIhAQy48BlDpZK184TwK2qrkIhicT+i4D2OgPsMBJgpxjiU4nsNla0DoO4z dP5qhGsS3jRuG82lBloQmO2nxV9baiojculqqLnL4GUdAA2dHWpl7Eyrwte5Sy4bTyV5LYTkA75r HNGKNuRvGQWfcI0pQeSe1N4CoTPzQHwyFh/0DYppvhI04aY3HBNubC4zpIBWBwVSfvdknZck9z8k c0Iy58qFOhfS+t6IZJpdCvBQEo+VzQmFvgTwAcAVtRfQkiEBWMmhrhhK8Bgxe1uddc2i8I77GPgH eSCU+G/VphZnkcRlT9RUyuZPAN4C+JOflwSRS2bvch+vCM0hOd0m4fyZcOGbG/lEpi7UcdnRRxUr wjJaZkpNvQfwF8d7WiThnFDWtvXjhjbUsviMbjhxbvTIAoGACIRQubSDvvRVTU0I4IKCX/DfRmLb 1CKPdm+xy+Kl1FGJkHnmyPyAAxpJ5vS5lWg4lyjVEv8N5Z2Fqy4XjEiQMNplYKh4MJSkpq6kfBji YaenYEtPYkVeugzYZy6wZKKhr3CtZlc2s7A4kwT5wuWXfkNEbHGtXk2x+M2cHoDvV60hWfK3SBbt i1UKRpoTmtubXEk5kzUzl61LF2JNUb5YrAUAEXwl/m8+F7oc0ZfmxdbKxXXupYUsJN43JUJtNevG o8q0qSNTkhZ4OFkrTEtwKxextJRIKfBSwvNBjU/bo2FaubXcJBM3gbBYnwoHlNAQQcznF6L9Nr/3 WBj+RB4ciBI0F2gYNUXM60Csa+rNrCkFmMtCZm4Nu3CRK+XfhpzfpfDnzLJjARA57uVykpEIZ4pt LVBIgZZw3Ik2NKRa1BhL0ovoNgbghH1FFYF8aa6RLxPSJ00V6TYWmEuFOeWiB+L72gz1hTsWgpcU 9kiOYfoSGnVPi1iWhafCp40tANGIlrefOawz60iY06PHvrNCSrBjDhM+aqiBpkymtwIg8yRuOpWw R4/PY3GRvmsNY2cFFcg21JO9gRyneO7cy3Hk3xwfqbS578rWAYADEUnn1JOM23QqUTiztyUJatj1 NVVVhr9jNftOKtqtSGyPlhczVpdDF8v1KKQlhISzSt3FRymEtYr2A8cnaj5pOpnYxAJwAkEKr8j5 v4JeSRNkm4cStao5ppg7us0VK9m3Uo5fN2l/GwBwMbp0f1u5oVl07nzX3Mxaxym1/In+br2Euc6X Ot+3Z9P7AZtom06EfD7kHTM6tThvLgVdLEnR7gvsYOuSZL3g5xUj0L0I/2wAcCFVa/zUhVg7cuxJ r5AKgLYcvxtpbyjwJV3GDgNqs+9zAcAlNp+lp9zYLjoGUuhpNRtLBWvAb2V8JWkXUmo3HvI+55bS 3076uzI9NjcFWbQJalwvkcx+52qttXdpu9wT66VfLM16V5r2qCaCBS40L3e54NjHTX3gwmosYfJR B8VHe42drpj2/V8N1L184vIA/Pn/sy759gnAr7nJ2j6v/Hj+Xw+AfwH+kNs1WYQ5vAAAAABJRU5E rkJggg==",
    transform: "matrix(1 0 0 1 35.9368 145.1816)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091016355673207545880000001509375255254501001_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.0118,
    y1: 159.9237,
    x2: 61.6575,
    y2: 185.0855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091016355673207545880000001509375255254501001_)"
    },
    d: "M54.18,168.74c0-0.11,0-0.23,0.01-0.34 l-9.62-1.6c-0.08,0.63-0.13,1.28-0.13,1.94c0,7.86,6.21,14.28,14,14.59v-9.76C56.04,173.27,54.18,171.22,54.18,168.74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070077451732293924130000007634503330824758708_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.4621,
    y1: 147.8185,
    x2: 75.1077,
    y2: 172.9803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070077451732293924130000007634503330824758708_)"
    },
    d: "M59.65,154.14v9.76 c2.4,0.3,4.26,2.35,4.26,4.83v0.04l9.65,1.6c0.06-0.54,0.09-1.08,0.09-1.64C73.65,160.87,67.44,154.46,59.65,154.14z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165206465404807356360000018427251043737208962_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.489,
    y1: 154.0942,
    x2: 68.1347,
    y2: 179.2561
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165206465404807356360000018427251043737208962_)"
    },
    d: "M59.65,173.57v9.76 c6.82-0.28,12.44-5.24,13.72-11.75l-9.62-1.6C63.25,171.88,61.64,173.32,59.65,173.57z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013886948045935268280000012550047550972268979_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.1202,
    y1: 153.5262,
    x2: 68.7658,
    y2: 178.688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013886948045935268280000012550047550972268979_)"
    },
    d: "M57.77,161.16v-12.05 c-8.91,0-16.31,6.45-17.8,14.94l11.89,1.97C52.4,163.25,54.84,161.16,57.77,161.16z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136399515148858087940000015111416749906719625_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.5559,
    y1: 149.4642,
    x2: 98.5519,
    y2: 179.3528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136399515148858087940000015111416749906719625_)"
    },
    d: "M92.69,153.61H77.9 c-0.14,0-0.26-0.12-0.26-0.26v-0.83c0-0.14,0.12-0.26,0.26-0.26h14.79c0.14,0,0.26,0.12,0.26,0.26v0.83 C92.95,153.5,92.84,153.61,92.69,153.61z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138572130195825712530000004717478593806417061_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.4505,
    y1: 150.0188,
    x2: 97.4465,
    y2: 179.9075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138572130195825712530000004717478593806417061_)"
    },
    d: "M92.72,159.51h-11.7 c-0.13,0-0.23-0.1-0.23-0.23v-0.89c0-0.13,0.1-0.23,0.23-0.23h11.7c0.13,0,0.23,0.1,0.23,0.23v0.89 C92.95,159.41,92.85,159.51,92.72,159.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005967724540149489270000012084371507377120695_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.6152,
    y1: 150.4379,
    x2: 96.6112,
    y2: 180.3265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005967724540149489270000012084371507377120695_)"
    },
    d: "M92.76,165.18h-8.17 c-0.11,0-0.19-0.09-0.19-0.19v-0.96c0-0.11,0.09-0.19,0.19-0.19h8.17c0.11,0,0.19,0.09,0.19,0.19v0.96 C92.95,165.1,92.87,165.18,92.76,165.18z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085242075983879104460000016448339884860849297_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.2617,
    y1: 152.1204,
    x2: 93.2577,
    y2: 182.0091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085242075983879104460000016448339884860849297_)"
    },
    d: "M92.73,170.86H81.92 c-0.12,0-0.22-0.1-0.22-0.22v-0.91c0-0.12,0.1-0.22,0.22-0.22h10.81c0.12,0,0.22,0.1,0.22,0.22v0.91 C92.95,170.76,92.85,170.86,92.73,170.86z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181073347219397729860000013805429532696316605_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.8138,
    y1: 154.8538,
    x2: 87.8098,
    y2: 184.7425
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181073347219397729860000013805429532696316605_)"
    },
    d: "M92.71,182.21H79.69 c-0.13,0-0.24-0.11-0.24-0.24v-0.86c0-0.13,0.11-0.24,0.24-0.24h13.02c0.13,0,0.24,0.11,0.24,0.24v0.86 C92.95,182.1,92.84,182.21,92.71,182.21z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041290398897055604500000017979060603965298839_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.2465,
    y1: 152.6298,
    x2: 92.2426,
    y2: 182.5184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041290398897055604500000017979060603965298839_)"
    },
    d: "M92.76,176.53h-7.73 c-0.1,0-0.19-0.08-0.19-0.19v-0.97c0-0.1,0.08-0.19,0.19-0.19h7.73c0.1,0,0.19,0.08,0.19,0.19v0.97 C92.95,176.45,92.87,176.53,92.76,176.53z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089547197058137737800000007600034290922786962_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.5214,
    y1: 109.0584,
    x2: 92.6781,
    y2: 107.9422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089547197058137737800000007600034290922786962_)"
    },
    d: "M45.8,129.96 c5.83,3.52,6.35-6.91,6.69-10.21c0.21-1.98,1.06-5.12,3.6-5.04c1.49,0.05,1.98,1.55,2.29,2.78c0.33,1.32,0.45,2.67,0.55,4.02 c0.18,2.51,0.32,5.08,1.4,7.4c0.79,1.69,2.57,3.35,4.51,2.29c1.64-0.9,2.35-3.09,2.72-4.8c0.6-2.83,1.01-5.7,1.38-8.57 c0.76-5.87,1.2-11.77,1.89-17.64c0.35-3.01,0.74-6.03,1.32-9.01c0.26-1.3,0.59-2.69,1.55-3.66c1.04-1.06,2.38-1.01,3.38,0.07 c0.93,1,1.28,2.41,1.6,3.71c0.35,1.43,0.68,2.86,1,4.29c0.63,2.89,1.2,5.8,1.71,8.71c1.02,5.79,1.7,11.63,2.61,17.43 c0.35,2.22,0.93,4.68,2.57,6.32c1.25,1.25,3.26,1.93,4.98,1.36c0.85-0.28,1.5-0.84,1.98-1.58c0.45-0.69-0.66-1.34-1.11-0.65 c-1.17,1.79-3.73,1.24-5.01-0.12c-1.7-1.79-2.03-4.59-2.34-6.93c-0.76-5.69-1.56-11.37-2.58-17.02c-0.51-2.86-1.08-5.7-1.71-8.54 c-0.54-2.43-0.86-5.42-2.41-7.46c-1.29-1.7-3.43-2.25-5.17-0.87c-1.96,1.57-2.26,4.36-2.64,6.67c-0.93,5.67-1.45,11.39-2.02,17.11 c-0.29,2.91-0.6,5.82-0.99,8.72c-0.37,2.72-0.68,5.57-1.44,8.21c-0.48,1.66-2.08,4.73-3.96,2.46c-1.64-1.98-1.72-5.02-1.89-7.46 c-0.16-2.28-0.2-5.15-1.54-7.11c-1.18-1.72-3.5-1.8-5.09-0.58c-2.62,2.01-2.36,5.82-2.73,8.78c-0.17,1.38-0.41,2.77-0.89,4.08 c-0.31,0.86-0.86,2.11-1.91,2.24c-0.58,0.07-1.16-0.23-1.64-0.52C45.74,128.42,45.09,129.53,45.8,129.96L45.8,129.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093863301752574448060000016704558413964738951_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.2779,
    y1: 112.4078,
    x2: 93.4091,
    y2: 112.4078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000093863301752574448060000016704558413964738951_)"
    },
    points: "89.52,134.86 89.18,135.49  91.45,136.73 40.86,136.73 40.86,88.06 41.89,89.94 42.52,89.6 40.4,85.71 38.28,89.6 38.91,89.94 40.14,87.68 40.14,136.73  40.14,136.73 40.14,137.45 40.14,137.45 40.86,137.45 91.06,137.45 89.18,138.47 89.52,139.1 93.41,136.98 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084527492935959074540000007389655799691719574_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.1987,
    y1: 179.7028,
    x2: 215.167,
    y2: 179.7028
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084527492935959074540000007389655799691719574_)"
    },
    d: "M122.63,175.99h72.46 c2.67,0,4.83,1.66,4.83,3.72c0,2.05-2.16,3.71-4.83,3.71h-72.46c-2.67,0-4.83-1.66-4.83-3.71 C117.8,177.65,119.96,175.99,122.63,175.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145757288464657410260000001411482215813860530_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.481,
    y1: 162.8831,
    x2: 181.4494,
    y2: 162.8831
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145757288464657410260000001411482215813860530_)"
    },
    d: "M136.87,159.17h40.02 c2.48,0,4.49,1.66,4.49,3.72c0,2.05-2.01,3.72-4.49,3.72h-40.02c-2.48,0-4.49-1.66-4.49-3.72 C132.39,160.83,134.4,159.17,136.87,159.17z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109005054087953457720000016271891131598595713_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.3913,
    y1: 162.8866,
    x2: 171.4506,
    y2: 162.8866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109005054087953457720000016271891131598595713_)"
    },
    d: "M119.41,162.89c0,2.05,1.67,3.71,3.71,3.71 c2.06,0,3.72-1.66,3.72-3.71c0-2.05-1.66-3.71-3.72-3.71C121.07,159.17,119.41,160.84,119.41,162.89z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemetria);
export default __webpack_public_path__ + "static/media/telemetria.9d3489f78c1a52c2c5b390fc4d36fc36.svg";
export { ForwardRef as ReactComponent };